/**
 * plp layout
 */
(() => {
  const plpPage = document.querySelectorAll('.ex-category, .ex-searchresult, .ex-content-page');
  if (!plpPage.length) return;

  const tileparentFunction = () => {
    const tileparent = document.querySelectorAll('.tileparent');
    tileparent.forEach((tile) => {
      if (tile.classList.contains('custom-done')) return;
      tile.classList.add('custom-done');

      const actionWrapper = document.createElement('div');
      const compareAction = tile.querySelector('.product-compare-action');
      const quicklistAction = tile.querySelector('.addtoquicklist-wrapper');
      if (compareAction && quicklistAction) {
        actionWrapper.innerHTML = /* html */ `
        <div class="action-wrapper">
          ${compareAction.outerHTML}
          ${quicklistAction.outerHTML}
        </div>
      `;
        tile.querySelector('.footer').appendChild(actionWrapper);
      }

      const brandLabel = tile.querySelector('.productsgrid_container .brand-label');
      if (brandLabel) {
        tile.querySelector('.productsgrid_container .tile > a').prepend(brandLabel);
      }

      const uomInclude = tile.querySelector('.footer-wrapper-price .uominclude');
      const footerWrapper = tile.querySelector('.footer-wrapper-description');
      if (uomInclude && footerWrapper) {
        footerWrapper.append(uomInclude);
      }

      const inventory = tile.querySelector('.buttons.group .live-inventory-v2-wrapper');
      const description = tile.querySelector('.footer-wrapper-description');

      if (inventory && description) {
        description.append(inventory);
      }
    });
  };

  const alternativeFunction = () => {
    document.querySelectorAll('.tileparent')
      .forEach((tile) => {
        if (tile.classList.contains('alternative-done')) return;
        tile.classList.add('alternative-done');

        const dataAlternateProduct = tile.getAttribute('data-erpalternateproduct');
        const inventoryOutStock = tile.querySelector('.live-inventory-v2-wrapper .out-stock');
        const addToCartButton = tile.querySelector('.live-inventory-v2-add-to-cart-wrapper button');
        if (dataAlternateProduct && inventoryOutStock && addToCartButton) {
          addToCartButton.textContent = 'See Alternatives';
        }
      });
  };

  tileparentFunction();

  document.addEventListener('live-pricing-done', () => {
    tileparentFunction();
    alternativeFunction();
  }, false);

  document.addEventListener('product-loadmore-success', (e) => {
    tileparentFunction();
    document.addEventListener('live-pricing-done', () => {
      tileparentFunction();
      alternativeFunction();
    }, false);
  }, false);

  const catalogName = document.querySelector('.productsgrid_container .catalog-name');
  if (catalogName) {
    document.querySelector('.productsgrid_container .gridtools').prepend(catalogName);
  }

  const gridItems = document.querySelector('.productgridwidget .griditems');
  const banner = document.querySelector('.js-plp-banner');
  if (gridItems && banner) {
    gridItems.prepend(banner);
  } else if (!gridItems && banner) {
    banner.style.display = 'none';
  }
})();

// if shop filters exists
(() => {
  const query = document.querySelector('.shop-filters');
  if (!query) return;

  // splitting filter name from filter count, so we can style them
  const filtersLoaded = () => {
    const filterItems = document.querySelectorAll('.shop-filters .filter-options:not(.swatch-grid) a:not(.lessfilteroption, .morefilteroption)');
    filterItems.forEach((item) => {
      let filterText = item.textContent;
      filterText = filterText.replace(/\s+[(]/g, ';(');
      const filterSplit = filterText.split(';');
      item.innerHTML = `<span class="filterOptionName">${filterSplit[0]}</span><span class="filterOptionCount">${filterSplit[1]}</span>`;
    });
  };

  // watch for skeleton filters being unhidden (data is loaded)
  const observer = new MutationObserver((e) => {
    if (e[0].target.style.display !== 'none') {
      console.log('filters loaded');
      filtersLoaded();
    }
  });

  const skeleton = document.querySelector('.skeleton-filters');
  if (skeleton) {
    observer.observe(skeleton, { attributes: true, childList: true });
  }
})();
